import { connect } from "react-redux";
import PaymentCodeManagement from "./PaymentCodeManagement";
import { actions } from "./actions";

export default connect(
  state => ({ paymentCodes: state.paymentCodes }),
  actions
)(PaymentCodeManagement);
